import React from 'react';

import { ReactComponent as ArrowUp } from '../../../../assets/icons/v3/up-arrow.svg';
import BdsTooltip from '../BdsTooltip/BdsTooltip';

import './MetricTile.scss';

interface IMetricTile {
  label: string;
  value: string;
  trend?: 'up' | 'down';
  tooltip?: string;
}

const MetricTile = ({ label, value, trend, tooltip }: IMetricTile) => {
  const renderTrend = () => {
    if (!trend) {
      return null;
    }

    const arrow = (
      <span className={`metric-tile-trend ${trend}`}>
        <ArrowUp />
      </span>
    );

    if (!tooltip) {
      return arrow;
    }

    return (
      <BdsTooltip message={tooltip} position="bottom-left">
        {arrow}
      </BdsTooltip>
    );
  };

  return (
    <div className="metric-tile">
      <span className="metric-tile-label">{label}</span>
      <div className="metric-tile-value-row">
        <span className="metric-tile-value">{value}</span>
        {renderTrend()}
      </div>
    </div>
  );
};

export default MetricTile;
